export const uploadImage = async (signedUrl: string, file: File) => {
  return fetch(signedUrl, {
    method: "PUT",
    body: new Blob([file]),
  });
};
